<template>
    <b-modal id="file_delete" ref="file_delete" header-class="no-border" footer-class="no-border"
             :title="'Delete ' + file.data.attributes.file_name + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('file_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteFile">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../Common/StateButton";

    export default {
        name: "FileDelete",

        components: {
            StateButton,
        },

        props: [
            'file', 'baseUrl',
        ],

        data() {
            return {

            }
        },

        computed: {
            url() {
                if (this.baseUrl.slice(-1) === '/') {
                    return this.baseUrl + this.file.attachment_id;
                }

                return this.baseUrl + '/' + this.file.attachment_id;
            }
        },

        methods: {
            deleteFile() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteFile', this.url)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated', this.file);

                                this.$notify('error filled', 'Success!', 'Deleted the file!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('file_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
            hideModal(refname) {
                this.$refs[refname].hide();
            },
        },
    }
</script>

<style scoped>

</style>
